import { DataTablesResponse } from "./datatables";
import { RenaultFileDTO } from "./renault-file-dto";
import { DistributorParams } from "./shared-dto";

export class CampaignCrmAnualSummaryModel {
  Month: number;
  Title: string;
  Status: number;
  Contact: CampaignCrmSummaryElementModel;
  ContactEmail: CampaignCrmSummaryElementModel;
  Success: CampaignCrmSummaryElementModel;
  Open: CampaignCrmSummaryElementModel;
  Clicks: CampaignCrmSummaryElementModel;
  Reactivity: CampaignCrmSummaryElementModel;
  OptOut: CampaignCrmSummaryElementModel;
  Reimpacted: CampaignCrmSummaryElementModel;
  ReimpactedPending: CampaignCrmSummaryElementModel;
  Resent: CampaignCrmSummaryElementModel;
  ResentOpen: CampaignCrmSummaryElementModel;
  ResentClick: CampaignCrmSummaryElementModel;
  ResentOptOut: CampaignCrmSummaryElementModel;
  WorkshopVisit: CampaignCrmSummaryElementModel;
  Rate: CampaignCrmSummaryElementModel;
  AverageTicket: CampaignCrmSummaryElementModel;
  Billing: CampaignCrmSummaryElementModel;
  ShowR2File: boolean;
}

export class CampaignCrmCampaignSummaryModel {
  Campaign: string;
  Code: string;
  IdCampaign: number;
  Contact: CampaignCrmSummaryElementModel;
  ContactEmail: CampaignCrmSummaryElementModel;
  Success: CampaignCrmSummaryElementModel;
  Open: CampaignCrmSummaryElementModel;
  Clicks: CampaignCrmSummaryElementModel;
  Reactivity: CampaignCrmSummaryElementModel;
  OptOut: CampaignCrmSummaryElementModel;
  Reimpacted: CampaignCrmSummaryElementModel;
  ReimpactedPending: CampaignCrmSummaryElementModel;
  Resent: CampaignCrmSummaryElementModel;
  ResentOpen: CampaignCrmSummaryElementModel;
  ResentClick: CampaignCrmSummaryElementModel;
  ResentOptOut: CampaignCrmSummaryElementModel;
  WorkshopVisit: CampaignCrmSummaryElementModel;
  Rate: CampaignCrmSummaryElementModel;
  AverageTicket: CampaignCrmSummaryElementModel;
  Billing: CampaignCrmSummaryElementModel;
}

export class CampaignCrmCampaignSummaryModelList {
  Year: string;
  Month: string;
  DataTotal: CampaignCrmCampaignSummaryModel;
  DataList: CampaignCrmCampaignSummaryModel[];
}


export class CampaignCrmClientEmailOrderFilter {
  DistributorFilters: DistributorParams = new DistributorParams();;
  Year: number = new Date().getFullYear();
  Month: number = 0;
}


export class CampaignCrmSummaryElementModel {
  Title: string;
  Data: string;
  DataPercent: string;
}

export class CampaignCrmClientFilter {
  DistributorFilters: DistributorParams = new DistributorParams();
  IdCampaign: number = 0;
  DealerCategory?: string;
  Year: number = new Date().getFullYear();
  Month: number = 0;
  MonthList: number[] = [];
}

export class CampaignCrmGlobalClientFilter {
  IdCampaign: number = 0;
  IdBrand = 0;
  Year: number = new Date().getFullYear();
  Month: number = 0;
  ClientSuccess: boolean | null = null;
}

export class CampaignCrmClientListFilter {
  DistributorFilters: DistributorParams = new DistributorParams();
  Year: number = new Date().getFullYear();
  Month: number = 0;
  IdStatus: number = 0;
  IdBrand: number = 0;
  IdCampaign: string[] = [];
  EmailOpen: boolean = false;
  EmailClick: boolean = false;
  ResentMail: boolean | null = null;
  DealerCategory?: string;
  ClientType?: string;

  constructor(year?, month?) {
    this.Year = year ?? new Date().getFullYear();
    this.Month = month ?? 0;
  }
}
export class CampaignCrmClientMassiveMailListFilter {
  DistributorFilters: DistributorParams = new DistributorParams();
  Year: number;
  Month: number;
  IdStatus: number;
  IdBrand: number;
  IdCampaign: string[];
  InvalidClientId: number[];
  InvalidCampaignId: string[];
  Search: string;
}


export class CampaignCrmClientManagementListModel {
  Highlights: CampaignCrmClientManagementListHighlightsModel;
  Table: DataTablesResponse;
}

export class CampaignCrmClientManagementListTableModel {
  Month: string;
  Campaign: string;
  Client: string;
  Plate: string;
  Estatus: string;
  IdCampaignCrmClient: string;
}

export class CampaignCrmClientManagementListHighlightsModel {
  Visits: string;
  Reimpacted: string;
  ReimpactedPending: string;
}

export class RenaultCampaignCrmClientDTO {
  IdCampaignCrmClient: string | null;
  IdCampaignCrypted: string | null;
  CompleteName: string;
  Address: string;
  PostalCode: string;
  Phone: string;
  Email: string;
  VehicleAge: number | null;
  Brand: string;
  ModelDescription: string;
  RegistrationNumber: string;
  CommunicationPermission: number;
  CanReimpactTel: boolean;
  CanReimpactMail: boolean;
  BajaTelefono: boolean;
  BajaMail: boolean;
  FechaVisita: string;
  FechaEmail: string;
  FechaLlamada: string;
  LastSendDate: string;
  IdCampaign: number;
  Month: number;
  Year: number;
  MonthYear: number;
  Language: number;
  Campaign: string;
  Distributor: string;
  ContactDate: string;
  CampaignArgumentativeFile: RenaultFileDTO | null;
  InitReimpactDatePhone: string;
  InitReimpactDateMail: string;
  EndReimpactDate: string;
  Configured: boolean;
  HasEmail: boolean;
  Vin?: string;
  ContractEndDate?: Date;
  WarrantyEndDate?: Date;
  ShowMyService?: number;
  ShowOffers?: number;
  PreferredDealer?: string;
  ClientType?: string;
}

export class RenaultCampaignCrmClientCallDTO {
  IdCall: string | null;
  IdClientData: string;
  IdCallStatus: string;
  IdEndsKoOption: string | null;
  StatusColor: string | null;
  Status: string | null;
  CreationUserName: string | null;
  Title: string | null;
  CallDate: string;
  Recall: boolean;
  RecallDate: string | null;
  Comments: string | null;
  EndsKoComment: string | null;
  EndsKoOption: string | null;
}

export class RenaultCampaignCrmClientEmailDTO {
  IdClientMail: string | null;
  IdStatus: number;
  Status: string;
  CreationDate: string;
  SendDate: string | null;
  DesiredDate: string | null;
  ContentHtml: string;
  Error: string;
}

export class RenaultCampaignCrmClientEmailPostDTO {
  IdClient: string;
  IdStatus: number;
  DesiredDate: string | null;
}

export class CampaignCrmClientMassiveEmailDataTableModel {
  Table: DataTablesResponse;
}

export class CampaignCrmClientStatisticsModel {
  Contact: number;
  ContactEmail: number;
  Success: number;
  Open: number;
  Click: number;
  Reimpact: number;
  Call: number;
  Email: number;
  Visit: number;
  Pending: number;
}



export class CampaignCrmClientStatisticsComparativeModel {
  Comparativa1: CampaignCrmClientStatisticsModel;
  Comparativa2: CampaignCrmClientStatisticsModel;
}


export class CampaignCrmClientStatisticsFilter {
  DistributorFilters: DistributorParams = new DistributorParams();
  DistributorFilters2: DistributorParams = new DistributorParams();
  IdBrand: number;
  IdCampaignList: string[] | null;
  Year: number;
  Month: string[] | null;
}

export class RenaultCampaignCrmClientEmailCampaignHtmlDTO {
  IdEmailCampaignHtml: string | null;
  IdPvGroup: number;
  IdCampaign: string;
  IdCampaignHtml: string;
  SubjectEsp: string | null;
  SubjectCat: string | null;
  Data: string | null;
  IdStatusEsp: number;
  IdStatusCat: number;
}

export class RenaultCampaignCrmClientEmailDistributorInstallation {
  IdDistributor: number;
  Distributor: string;
  Installations: RenaultCampaignCrmClientEmailInstallation[];
}

export class RenaultCampaignCrmClientEmailInstallation {
  IdInstallation: number;
  Address: string;
  Town: string;
  Province: string;
  DealerId: string;
  IdDistributor: string;
}

export class CampaignCrmClientEmailCampaign {
  IdCampaignCrm: string;
  Brand: string;
  CampaignCode: string;
  RecsaCode: string;
  Description: string;
  Configured: boolean;
  PvGroup: string;
  IdPvGroup: number;
}

export class CampaignCrmClientMassiveEmailNotConfigured {
  OkToSend: boolean;
  Data: CampaignCrmClientEmailCampaign[];
  Contact: number;
}

export class CampaignCrmClientEmailStatisticsModel {
  Status: CampaignCrmClientEmailStatisticsStatusModel[];
  Abiertos: number;
  Clicks: number;
  ClicksTotales: number;
  TotalBbdd: number;
  OptOut: number;
  Visitas: number;
}

export class CampaignCrmClientEmailStatisticsStatusModel {
  IdStatus: number;
  Contador: number;
}

export class CampaignCrmClientEmailStatisticsTimechartModel {
  CreationDate: string;
  IdLogType: number;
  Contador: number;
}

export class CampaignCrmClientEmailStatisticsTableModel {
  Campaign: string;
  Code: string;
  Total: string;
  Enviados: string;
  Abiertos: string;
  ClicksUnicos: string;
  ClicksTotales: string;
  Bajas: string;
  Visitas: string;
  Html?: string;
}

export class CampaignCrmGlobalAnualSummaryModel {
  Month: number;
  Title: string;
  Contact: CampaignCrmSummaryElementModel;
  ContactEmail: CampaignCrmSummaryElementModel;
  Success: CampaignCrmSummaryElementModel;
  Open: CampaignCrmSummaryElementModel;
  Clicks: CampaignCrmSummaryElementModel;
  OptOut: CampaignCrmSummaryElementModel;
  WorkshopVisit: CampaignCrmSummaryElementModel;
  Rate: CampaignCrmSummaryElementModel;
}
export class CampaignCrmGlobalCampaignSummaryModelList {
  Year: string;
  Month: string;
  DataTotal: CampaignCrmGlobalCampaignSummaryModel;
  DataList: CampaignCrmGlobalCampaignSummaryModel[];
}


export class CampaignCrmGlobalCampaignSummaryModel {
  Campaign: string;
  Code: string;
  IdCampaign: number;
  Contact: CampaignCrmSummaryElementModel;
  ContactEmail: CampaignCrmSummaryElementModel;
  Success: CampaignCrmSummaryElementModel;
  Open: CampaignCrmSummaryElementModel;
  Clicks: CampaignCrmSummaryElementModel;
  OptOut: CampaignCrmSummaryElementModel;
  WorkshopVisit: CampaignCrmSummaryElementModel;
  Rate: CampaignCrmSummaryElementModel;
}

export class RenaultCampaignCrmClientEmailViewContentDTO {
  ContentHtml: string;
}